import { Api } from '@/interface/api';

/**
 * 微信ticket
 */
const weixinJsapiTicket: Api = {
    url: '/api/weixin/jsapi/ticket',
    method: 'get',
};

export {
    weixinJsapiTicket,
};
